import type { LocalStore } from "./storage.js";
import type { AnyProperties } from "./types.js";

const USER_KEY = "uid";
const TRAITS_KEY = "traits";

export class IdentityManager {
  private storage: LocalStore;
  private userId: string | null;
  private traits: AnyProperties;

  constructor(storage: LocalStore) {
    this.storage = storage;
    this.userId = storage.get(USER_KEY);
    this.traits = storage.getJson<AnyProperties>(TRAITS_KEY) ?? {};
  }

  identify(userId: string, traits?: AnyProperties): void {
    this.userId = userId;
    this.storage.set(USER_KEY, userId);
    if (traits) {
      this.traits = { ...this.traits, ...traits };
      this.storage.setJson(TRAITS_KEY, this.traits);
    }
  }

  getUserId(): string | null {
    return this.userId;
  }

  getTraits(): AnyProperties {
    return { ...this.traits };
  }

  reset(): void {
    this.userId = null;
    this.traits = {};
    this.storage.remove(USER_KEY);
    this.storage.remove(TRAITS_KEY);
  }
}
